const Environment = (() => {
  const environment = {};

  const getBaseURL = () => {
    switch (process.env.BABEL_ENV) {
      case 'development':
        return 'http://localhost:3000/api';
      default:
        return '/api';
    }
  };

  const getEnvironment = () => process.env.BABEL_ENV;

  environment.getBaseURL = getBaseURL;
  environment.getEnvironment = getEnvironment;

  return environment;
})();

export default Environment;
